import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BidvBankTransferService } from 'services/openapi';

import { BidvBankTransferServiceKeys } from '../queries/constants';
import { BidvBankTransferWhitelistEntity } from '../queries/useGetBidvBankTransferWhitelistQuery';

export type UpdateBidvBankTransferWhitelistDto = {
  compId?: string;
  whitelist: string[];
};

export const useUpdateBidvBankTransferWhitelistMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      BidvBankTransferWhitelistEntity,
      Error,
      UpdateBidvBankTransferWhitelistDto
    >({
      mutationFn: (variables: UpdateBidvBankTransferWhitelistDto) => {
        return BidvBankTransferService.bidvBankTransferControllerUpdateWhitelist(
          variables,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BidvBankTransferServiceKeys.GET_BANK_TRANSFER_WHITELIST],
        });
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
